module.exports = __webpack_public_path__ + "55bd2313bf69c49344b822c484793d33.pdf";